import React, { useEffect, useRef } from 'react'; // Add useRef hook
import './About.css';
import { Application } from '@splinetool/runtime'; // Import the Spline runtime at the top

function About() {
    const canvasRef = useRef(null); // Create a reference to get the canvas DOM element

    useEffect(() => {
        const canvas = canvasRef.current; // Get the canvas DOM element
        const app = new Application(canvas); // Initialize the Spline runtime
        app.load('https://prod.spline.design/RAgKvKVcKs36Cud7/scene.splinecode'); // Load your 3D scene

        // Return a cleanup function to dispose of the app when component unmounts
        return () => {
            app.dispose();
        };
    }, []);

    return (
        <div className="about">
            <div className="visual-content-about">
                {/* Replace the img tag with the canvas element */}
                <canvas id="canvas3d" ref={canvasRef} className="camera"></canvas>
            </div>
            <div className="text-container-about">
                <h2 className="welcome-text">Sobre nosotros</h2>
                <p className="subtext-smaller-about" id='about-description'>Somos un grupo de talentos de <strong>marketeros , diseñadores UX , fotógrafos, videomakers , directores creativos y expertos</strong> en tecnología y  lo que tenemos en común  es crear. Nos enfocamos en tener exclusividad para cada trabajo que vayamos a realizar con distintivas empresas y marcas con las que podamos hacer un match perfecto.</p>
                <a className="main-button" href="#services">Contáctanos</a>
            </div>
        </div>
    );
}

export default About;
